import React from 'react';
import { Modal, Button, Header, List, Message } from 'semantic-ui-react';

interface ExamDisclaimerProps {
  open: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

const ExamDisclaimer: React.FC<ExamDisclaimerProps> = ({
  open,
  onAccept,
  onCancel
}) => {
  return (
    <Modal open={open} size="large" closeOnDimmerClick={false}>
      <Modal.Header>Exam Disclaimer - Anti-Cheat Measures</Modal.Header>
      <Modal.Content>
        <Message warning>
          <Message.Header>Important</Message.Header>
          <p>
            Please read the following rules carefully. By proceeding, you agree to
            comply with all exam integrity measures. Violations may result in
            disqualification.
          </p>
        </Message>

        <Header as="h4">During the exam, you must NOT:</Header>
        <List bulleted>
          <List.Item>Switch to another browser tab or window</List.Item>
          <List.Item>Open a different browser or application</List.Item>
          <List.Item>Minimize the browser window</List.Item>
          <List.Item>Copy or paste content</List.Item>
        </List>

        <Header as="h4">What we monitor:</Header>
        <List bulleted>
          <List.Item>
            <strong>Tab & Window Focus:</strong> Any time you leave the exam tab
            will be logged and may be reviewed.
          </List.Item>
          <List.Item>
            <strong>Webcam:</strong> A silent photo will be taken periodically to
            verify your identity.
          </List.Item>
          <List.Item>
            <strong>Copy/Paste:</strong> Copy and paste actions are disabled and
            attempts are logged.
          </List.Item>
        </List>

        <Message negative>
          <Message.Header>Consequences</Message.Header>
          <p>
            If you violate any of these measures, the exam will end automatically
            and whatever you have completed will be submitted automatically. Your
            exam may also be flagged for review and could result in a failing grade
            or other disciplinary action.
          </p>
        </Message>

        <p>
          Do you understand and accept these terms? Click &quot;I Understand and
          Accept&quot; to proceed with the exam.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button primary onClick={onAccept}>
          I Understand and Accept
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ExamDisclaimer;
